import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import {Img} from 'ui';
import Slider from 'react-slick';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  textAlign: 'center',
});

export const Slides = styled(Slider)({
  width: '100vw',
});

export const Image = styled(Img)({
  width: 200,
  height: 130,
});

export const Title = styled('div')({
  fontFamily: fonts.title,
  fontSize: 26,
  color: colors.darkBrown,
  fontWeight: 'bold',
  marginTop: 30,
  marginBottom: 15,
});

export const SubTitle = styled('div')({
  marginTop: 24,
  marginBottom: 15,
  fontSize: 16,
  color: colors.caramel,
});
